import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-57cba7a2"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "image-container"
};
const _hoisted_2 = {
  class: "info-container"
};
const _hoisted_3 = {
  class: "font-subtitle1 row main"
};
const _hoisted_4 = ["title"];
const _hoisted_5 = {
  class: "font-caption1 row sub"
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Base Value", -1));

const _hoisted_7 = {
  class: "value-wrapper"
};
const _hoisted_8 = {
  class: "font-caption1"
};
const _hoisted_9 = {
  class: "font-overline currency"
};
const _hoisted_10 = {
  class: "font-caption1 row sub"
};

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Reward", -1));

const _hoisted_12 = {
  class: "value-wrapper"
};
const _hoisted_13 = {
  class: "font-caption1"
};
const _hoisted_14 = {
  class: "font-overline currency"
};
const _hoisted_15 = {
  class: "font-caption1 row sub"
};

const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Bonus", -1));

const _hoisted_17 = {
  class: "value-wrapper"
};
const _hoisted_18 = {
  class: "font-caption1"
};
const _hoisted_19 = {
  class: "font-overline currency"
};
const _hoisted_20 = {
  class: "card-footer"
};
const _hoisted_21 = {
  class: "row"
};
const _hoisted_22 = {
  class: "font-caption1 token-id"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["product-card-wrapper", {
      'quasi-staking': $props.quasiStaking
    }])
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
    class: "image",
    style: _normalizeStyle(`background-image: url(${$props.product.image})`)
  }, null, 4)]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", {
    class: "text-hidden",
    title: `${$props.product.name}`
  }, _toDisplayString($props.product.name || "-"), 9, _hoisted_4)]), !$props.quasiStaking ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, _toDisplayString($props.product.baseValue.amount || "-"), 1), _createElementVNode("span", _hoisted_9, _toDisplayString($props.product.baseValue.token || "-"), 1)])]), _createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("div", _hoisted_12, [_createElementVNode("span", _hoisted_13, _toDisplayString($props.product.reward.amount || "0"), 1), _createElementVNode("span", _hoisted_14, _toDisplayString($props.product.reward.token || "BCNT"), 1)])])], 64)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("div", _hoisted_17, [_createElementVNode("span", _hoisted_18, _toDisplayString($props.product.bonus.amount || "0"), 1), _createElementVNode("span", _hoisted_19, _toDisplayString($props.product.bonus.token || "BCNT"), 1)])])]), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", {
    class: "project-image",
    style: _normalizeStyle(`background-image: url(${$props.product.project.image})`)
  }, null, 4), _createElementVNode("span", _hoisted_22, _toDisplayString($props.product.project.name || "-"), 1), $props.isClaim ? (_openBlock(), _createElementBlock("button", {
    key: 0,
    class: "btn sm claim",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.claim && $options.claim(...args))
  }, " Claim ")) : _createCommentVNode("", true)])])], 2);
}